import axios from 'axios';

export const userService = {
    auth,
    logout
};
function auth(idToken) {
    return axios({
        method: 'post',
        url: '/auth',
        data: {
            "id_token": idToken,
        }
    }).then(handleResponse)
        .then(user => {
            if (user.token) {
                localStorage.setItem('user', JSON.stringify(user))
            }
            return user
        })
}
function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function handleResponse(response) {
    const data = response.data
    if (response.status != 200) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            logout();
            location.reload(true);
        }

        const error = data || response.statusText;
        return Promise.reject(error);
    }

    return data;
}
